import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Help } from '@mui/icons-material'
import { InputAdornment } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import TextField from './TextField'
import { toLower } from 'ramda'

const FullTextSearchField = ({ label, value, onChange, fields, style, ...other }) => {
  const { t } = useTranslation()
  return (
    <TextField
      style={style}
      label={label === undefined ? t('common:generic.Filter') : label}
      value={value}
      onChange={onChange}
      {...other}
      InputProps={{
        endAdornment: (
          <Tooltip
            title={t('common:ui.SearchFields', {
              fields: fields.map(toLower).join(', '),
            })}
          >
            <InputAdornment position="end">
              <Help color="info" style={{ cursor: 'help' }} />
            </InputAdornment>
          </Tooltip>
        ),
      }}
    />
  )
}

FullTextSearchField.defaultProps = {
  style: {},
}

FullTextSearchField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object,
  fields: PropTypes.arrayOf(PropTypes.string),
}

export default FullTextSearchField
